export default __webpack_public_path__ + "static/media/boba-desktop-share-modal-bottom-ribbon.bc9fc3c6.svg";